/* eslint-disable */
import React, { Component } from 'react';
import { Form, Button, Grid, Header, Image, Segment } from 'semantic-ui-react';
import { inject, observer } from 'mobx-react' ;
import { withRouter } from 'react-router-dom';

@inject('AuthStore')
@observer
class SignIn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      password: '',
      error: '',
    };
  }

  handleSignIn = async (e) => {
    e.preventDefault();
    const { username, password } = this.state;
    if (!username || !password) {
      this.setState({ error: 'Preencha username e senha para continuar!' });
    } else {
      try {
        await this.props.AuthStore.signIn({ username, password });
        if (this.props.AuthStore.isAuthenticated) {
            this.props.history.push('/');
        }
      } catch (err) {
        this.setState({
          error:
            'Houve um problema com o login, verifique suas credenciais. T.T',
        });
      }
    }
  };

  render() {
    return (
      <Grid textAlign='center' style={{ height: '100vh' }} verticalAlign='middle'>
        <Grid.Column style={{ maxWidth: 450 }}>
        <Header as='h2' color='teal' textAlign='center'>
          <Image src='/logo.png' /> Entre com seus dados
      </Header>
        <Form size="large" onSubmit={this.handleSignIn}>
          <Segment stacked>
          {this.state.error && <p>{this.state.error}</p>}
          <Form.Input
            className="username"
            fluid icon="user"
            iconPosition="left"
            onChange={(e) => this.setState({ username: e.target.value })}
            placeholder="Usuário"
            type="text"
          />
          <Form.Input
            className="password"
            fluid icon="lock"
            iconPosition="left"
            onChange={(e) => this.setState({ password: e.target.value })}
            placeholder="Senha"
            type="password"
          />
          <Button
            className="signin-button"
            color="teal"
            fluid size="large"
            type="submit"
          >Entrar</Button>
          </Segment>
        </Form>
        </Grid.Column>
      </Grid>
    );
  }
}

export default withRouter(SignIn);
